import ConfirmationView from './components';

const WishlistConfirmationViewPage = () => {
  return (
    <div className="flex items-center justify-center">
      <ConfirmationView />
    </div>
  );
}

export default WishlistConfirmationViewPage;
